import React from 'react';
import { TextField, Button, Grid, Typography } from '@mui/material';

const ResumePortfolio = ({ formData, setFormData }) => {
  // Ensure resume and workSamples are arrays
  if (!Array.isArray(formData.resume)) {
    formData.resume = [];
  }
  if (!Array.isArray(formData.workSamples)) {
    formData.workSamples = [];
  }
  const handleFileChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.files[0] });
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <input
          accept=".pdf,.doc,.docx"
          style={{ display: 'none' }}
          id="resume-upload"
          type="file"
          name="resume"
          onChange={handleFileChange}
        />
        <label htmlFor="resume-upload">
          <Button variant="contained" component="span">
            Upload Resume
          </Button>
        </label>
        {formData.resume && <Typography>{formData.resume.name}</Typography>}
      </Grid>
      <Grid item xs={12}>
        <input
          accept=".pdf,.doc,.docx"
          style={{ display: 'none' }}
          id="work-samples-upload"
          type="file"
          name="workSamples"
          onChange={handleFileChange}
        />
        <label htmlFor="work-samples-upload">
          <Button variant="contained" component="span">
            Upload Work Samples
          </Button>
        </label>
        {formData.workSamples && <Typography>{formData.workSamples.name}</Typography>}
      </Grid>
    </Grid>
  );
};

export default ResumePortfolio;